import styled from 'styled-components';

import {
  black,
  boxShadow1,
  gray,
  lightGray,
  red,
  whitesmoke,
} from 'utils/style/colors';

interface IInputContainerProps {
  focused: boolean;
  disabled?: boolean;
  round?: boolean;
}

interface IChipInputProps {
  values?: Array<any>;
}

interface IChipProps {
  selected: boolean;
}

interface ItemListProps {
  inPopover?: boolean;
}

interface ISelectOptionProps {
  active: boolean;
  selected: boolean;
  disabled?: boolean;
  selectionIndicator: boolean;
}
interface SpaceOptions {
  depth: number;
}

export const Wrapper = styled('div')`
  position: relative;
`;

export const Label = styled('label')`
  color: ${black} !important;
  font-size: 1rem !important;
  position: initial !important;
  padding-inline-start: 0.25rem;
  font-weight: bold;
`;

export const InputContainer = styled('div')<IInputContainerProps>`
  margin: 0.5rem 0;
  padding: 0.1rem 0.5rem;
  min-height: ${(props) => (props.round ? '27px' : '30px')};
  outline: none;
  transition: all 0.3s;
  /* border-width: 1px;
  border-style: solid;
  border-color: ${(props) =>
    props.focused ? 'var(--gray)' : 'var(--gray)'}; */
  box-shadow: ${(props) => (props.focused ? `0 0 0 2px ${lightGray}` : 'none')};
  border-radius: ${(props) => (props.round ? '0.5rem' : '10px')};
  background-color: var(--input-background);
  box-sizing: border-box;
  &:hover {
    border-color: ${gray};
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ disabled }) =>
    disabled &&
    `
    color: #A2AEB6;
    // background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAP0lEQVQoU43M2QkAIAwEUVPI9l/YFqJEUDxyzfdjpBUi2SVzigBICBfSmQtP5MIXmdBCH/TQBSO0YYYmrCCFA4f8J7ORXNL2AAAAAElFTkSuQmCC) repeat;
    pointer-events: none;
    // & > * {
    //   opacity: 0.5;
    // }
  `}
`;

export const ChipsInput = styled('input')<IChipInputProps>`
  background: none;
  border: 0;
  color: ${black};
  display: inline-block;
  font-size: 1rem;
  height: 2rem;
  line-height: 2rem;
  outline: 0;
  padding: 0 !important;
  max-width: calc(100% - 22px);
  &::placeholder {
    color: ${({ values }) => ((values?.length || 0) > 0 ? black : black)};
  }
`;

export const Chip = styled('span')<IChipProps>`
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 2rem;
  padding: 0 0.5rem;
  border-radius: 10px;
  color: ${(props) =>
    props.selected ? 'var(--exact-white)' : black} !important;
  background-color: ${(props) =>
    props.selected ? black : lightGray} !important;
  margin: 3px;
`;

export const ItemList = styled('ul')<ItemListProps>`
  display: block;
  ${({ inPopover }) =>
    !inPopover
      ? `position: absolute;
  width: 100%;`
      : ''}
  top: auto;
  min-width: 50px;
  right: 0;
  max-height: ${({ inPopover }) => (!inPopover ? '12.5rem' : '50vh')};
  background-color: var(--exact-white);
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  overflow-y: auto;
  margin: 0;
  z-index: 10001;
`;

export const SelectOptionWrapper = styled('li')`
  display: flex;
  cursor: pointer;
`;
export const Space = styled('div')<SpaceOptions>`
  width: ${(props) => props.depth * 30 + 'px'};
`;
export const SelectOption = styled('div')<ISelectOptionProps>`
  padding: 0.5rem;
  flex-grow: 1;
  display: flex;
  border-bottom: 1px solid ${whitesmoke};
  color: ${black};
  align-items: center;
  &:last-child {
    border: none;
  }
  border-radius: 10px;
  margin: 2px;
  padding: 4px;
  ${({ active, disabled }) =>
    active &&
    !disabled &&
    `
      background-color: ${lightGray};
    `}
  ${({ disabled }) =>
    disabled &&
    `
      cursor: default;
      color: ${lightGray} !important;
    `}
  ${({ selected, selectionIndicator }) =>
    selected &&
    !selectionIndicator &&
    ` background-color: ${black};
      color: var(--exact-white) !important;
      flex-grow: 0;
    `}
`;
type SingleValueOptions = {
  error?: boolean;
};
export const SingleValue = styled('span')<SingleValueOptions>`
  color: ${({ error }) => (error ? red : black)};
  overflow: hidden;
  margin: 3px 3px;
`;

export const SelectIcons = styled('span')`
  color: silver;
  display: flex;
  align-items: center;
  & > span {
    margin: 0 0.5rem;
  }
  & > i {
    cursor: pointer;
  }
`;

export const ChipsWrapper = styled('div')`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  max-height: 50vh;
  overflow: auto;
`;
